'use client'

// lib files
import { usePersonalizedResourceFetch } from '@/lib/hooks/usePersonalizedResource';
import { myListShows } from '@/lib/resources/my-list-shows';

function NetworkMyListShows() {
  usePersonalizedResourceFetch(myListShows)

  return (<></>)
}

export default NetworkMyListShows
